import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';

import { AssociativaLegaliForm } from '../../../form/associativa-legali-form';

import { SezioneLegaliResponse } from '../../../models/dto/sezione-legali-response';
import { Legale } from '../../../models/legale';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';

@Component({
  selector: 'div [associativa-legali-form-add]',
  templateUrl: '../../../form/associativa-legali-form.html',
})
export class LegaliAssociativaAddComponent extends AssociativaLegaliForm
  implements OnInit {
  private addLegaleUrl: string;
  private idSezione: string;
  private idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneLegali> = new EventEmitter<
    SezioneLegali
  >();

  ngOnInit() {
    this.isInserimento(true);
  }

  constructor(
    @Inject(OperationsService) operationService: OperationsService,
    @Inject(FormBuilder) campiForm: FormBuilder,
    @Inject(HelpersService) helpers: HelpersService
  ) {
    super(operationService, campiForm, helpers);
  }

  getRequest(request: LegaleIncaricato) {
    this.operationService
      .addParteOrLegaleInSezOrdinario(
        request,
        this.addLegaleUrl,
        this.idSezione,
        this.idFascicolo
      )
      .subscribe((response) =>
        this.addedLegali(<SezioneLegaliResponse>response)
      );
  }

  addedLegali(response: SezioneLegaliResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getLegaleIncaricato(): LegaleIncaricato {
    return new LegaleIncaricato();
  }

  inizializza(
    legale: Legale,
    addLegaleUrl: string,
    idSezione: string,
    idFascicolo: string
  ) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.addLegaleUrl = addLegaleUrl;
    this.setLegale(legale);
    this.populateSelect();
    this.createForm();
  }

  canCheckPrimary(): boolean {
    return true;
  }
}
